import { Immutable } from "immer";
import React from "react";

import { RichText } from "../RichText";

// Body block types for TempurLove/CustomerContentHub Story pages
// Types are intentionally mutable to match StreamField component requirements.
type SpacingBlockValue = {
    top_spacing?: string | null;
    top_inner_spacing?: string | null;
    bottom_spacing?: string | null;
    bottom_inner_spacing?: string | null;
};

type BodyBlock =
    | {
          type: "content";
          value: string;
          id: string;
      }
    | {
          type: "spacing";
          value: SpacingBlockValue;
          id: string;
      };

/**
 * Bridge between Reactivated's Immutable StreamField data and
 * thelabui's StreamField component which expects mutable types.
 */
export const toBodyBlocks = (value: Immutable<BodyBlock[]>): BodyBlock[] =>
    structuredClone(value) as BodyBlock[];

// Body block components
export const ContentBlock = (props: { value: string }): React.JSX.Element => {
    return <RichText html={props.value} suppressHydrationWarning={true} />;
};

export const SpacingBlock = (props: {
    value: SpacingBlockValue;
}): React.JSX.Element => {
    const {
        top_spacing,
        top_inner_spacing,
        bottom_spacing,
        bottom_inner_spacing,
    } = props.value;
    const classes = [
        top_spacing && `top-spacing top-${top_spacing}`,
        top_inner_spacing && `top-inner-spacing top-inner-${top_inner_spacing}`,
        bottom_spacing && `bottom-spacing bottom-${bottom_spacing}`,
        bottom_inner_spacing &&
            `bottom-inner-spacing bottom-inner-${bottom_inner_spacing}`,
    ]
        .filter(Boolean)
        .join(" ");

    if (!classes) return <></>;
    return <div className={classes} />;
};
